import React, { useState, useEffect } from 'react';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import DropdownDivider from '../DropdownMenu/DropdownDivider';
import Field from '../Field/Field';
import { FieldType } from '../_types';
var TableOptionsDropDown = function (props) {
    var _a = props.isSmall, isSmall = _a === void 0 ? false : _a, onChange = props.onChange;
    var _b = useState(isSmall), innerIsSmall = _b[0], setInnerIsSmall = _b[1];
    useEffect(function () { return setInnerIsSmall(isSmall); }, [isSmall]);
    var handleOnChange = function (event, nativeEvent) {
        onChange && onChange((event === null || event === void 0 ? void 0 : event.value) === 'true', nativeEvent);
    };
    return (React.createElement(DropdownMenu, { iconClass: "fal fa-cog fa-lg", customClass: "table-options-dropdown" },
        React.createElement("li", { className: "h3 my-0 px-4" }, "Table size"),
        React.createElement(DropdownDivider, null),
        React.createElement("li", { className: "mx-4 m-0" },
            React.createElement(Field, { value: { radioGroupField: innerIsSmall }, field: {
                    name: 'radioGroupField',
                    type: FieldType.Radio,
                    optionalTag: false,
                    options: [
                        {
                            value: true,
                            text: 'Small'
                        },
                        {
                            value: false,
                            text: 'Large'
                        }
                    ]
                }, onChange: handleOnChange }))));
};
export default React.memo(TableOptionsDropDown);
